import { Component } from '@angular/core';


@Component({
  selector: 'app-customer-profile-config',
  templateUrl: './customer-profile-config.component.html',
  styleUrls: ['./customer-profile-config.component.css']
})
export class CustomerProfileConfigComponent {}
